var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9505 5.12549C21.2814 5.12549 21.5876 5.22036 21.8557 5.37436L12.7005 12.7856L3.54531 5.37436C3.81344 5.22036 4.1196 5.12549 4.45052 5.12549H20.9505ZM12.9888 13.7316L22.5162 6.01924C22.6826 6.29515 22.7839 6.61415 22.7839 6.95882V17.0422C22.7839 18.0532 21.9616 18.8755 20.9505 18.8755H4.45052C3.43944 18.8755 2.61719 18.0532 2.61719 17.0422V6.95882C2.61719 6.61415 2.71848 6.29515 2.88485 6.01924L12.4122 13.7316C12.4937 13.7979 12.5955 13.834 12.7005 13.8338C12.8055 13.834 12.9074 13.7979 12.9888 13.7316Z",
    fill: "#6B7880"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 21,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9505 5.12549C21.2814 5.12549 21.5876 5.22036 21.8557 5.37436L12.7005 12.7856L3.54531 5.37436C3.81344 5.22036 4.1196 5.12549 4.45052 5.12549H20.9505ZM12.9888 13.7316L22.5162 6.01924C22.6826 6.29515 22.7839 6.61415 22.7839 6.95882V17.0422C22.7839 18.0532 21.9616 18.8755 20.9505 18.8755H4.45052C3.43944 18.8755 2.61719 18.0532 2.61719 17.0422V6.95882C2.61719 6.61415 2.71848 6.29515 2.88485 6.01924L12.4122 13.7316C12.4937 13.7979 12.5955 13.834 12.7005 13.8338C12.8055 13.834 12.9074 13.7979 12.9888 13.7316Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7687e8dc11e1a5ec47fa60fbf6f3c449.svg";
export { ForwardRef as ReactComponent };